import React from 'react';
import { motion } from 'framer-motion';

function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: "Building a $1M Micro SaaS: The Complete Guide",
      excerpt: "Learn the step-by-step process of building a successful micro SaaS business, from ideation to $1M in revenue. Discover key strategies for product development, marketing, and scaling.",
      date: "2024-03-20",
      category: "SaaS",
      readTime: "15 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Micro SaaS", "Startup", "Product Management"],
      featured: true
    },
    {
      id: 2,
      title: "Product Management in the Age of AI",
      excerpt: "How artificial intelligence is transforming product management and what it means for the future of the industry. Explore the intersection of AI and product development.",
      date: "2024-03-18",
      category: "AI",
      readTime: "10 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["AI", "Product Management", "Future of Work"],
      featured: true
    },
    {
      id: 3,
      title: "From Idea to Launch: A Product Manager's Journey",
      excerpt: "A detailed look at the journey of bringing a product from concept to market. Learn about the challenges, decisions, and strategies that lead to success.",
      date: "2024-03-15",
      category: "Product Management",
      readTime: "12 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Product Launch", "Strategy", "Leadership"],
      featured: true
    },
    {
      id: 4,
      title: "The Future of Product Management: AI Agents and Automation",
      excerpt: "Exploring how AI agents are revolutionizing product management workflows and decision-making processes. Learn how to leverage AI for better product outcomes.",
      date: "2024-03-12",
      category: "AI",
      readTime: "8 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["AI Agents", "Automation", "Product Management"]
    },
    {
      id: 5,
      title: "Scaling Your SaaS: From MVP to Market Leader",
      excerpt: "Key strategies and insights for scaling your SaaS product from minimum viable product to market leadership. Learn from real-world examples and case studies.",
      date: "2024-03-10",
      category: "SaaS",
      readTime: "14 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Scaling", "Growth", "Strategy"]
    },
    {
      id: 6,
      title: "Data-Driven Product Decisions: A Framework",
      excerpt: "A comprehensive framework for making data-driven product decisions. Learn how to collect, analyze, and act on product data effectively.",
      date: "2024-03-08",
      category: "Product Management",
      readTime: "11 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Data", "Analytics", "Decision Making"]
    },
    {
      id: 7,
      title: "Understanding AI Agent Limitations: What They Can't Do",
      excerpt: "A critical look at the current limitations of AI agents in product management. Learn about the boundaries and constraints of AI technology.",
      date: "2024-03-05",
      category: "AI",
      readTime: "9 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["AI Limitations", "Technology", "Critical Thinking"]
    },
    {
      id: 8,
      title: "Security Considerations for AI-Powered Products",
      excerpt: "Essential security practices for developing and deploying AI-powered products. Learn how to protect sensitive data and ensure compliance.",
      date: "2024-03-03",
      category: "Security",
      readTime: "13 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Security", "AI", "Compliance", "Data Protection"]
    },
    {
      id: 9,
      title: "Ethical AI in Product Management: A Framework",
      excerpt: "How to implement ethical AI practices in your product development process. Learn about bias, fairness, and responsible AI deployment.",
      date: "2024-02-28",
      category: "AI",
      readTime: "10 min read",
      author: "Ayokunle (Kay) Fadiora",
      tags: ["Ethics", "AI", "Responsibility", "Bias"]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-3xl font-extrabold text-white sm:text-4xl mb-4">
            Blog
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Insights and thoughts on product management, AI, and SaaS development
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="glass-card rounded-lg overflow-hidden hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm text-indigo-400">{post.category}</span>
                  <span className="text-sm text-gray-400">{post.readTime}</span>
                </div>
                <h2 className="text-xl font-bold text-white mb-2">{post.title}</h2>
                <p className="text-gray-300 mb-4">{post.excerpt}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {post.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="text-xs px-2 py-1 rounded-full bg-gray-800 text-gray-300"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-700">
                  <div className="flex items-center">
                    <div className="text-sm">
                      <p className="text-indigo-400 font-medium">{post.author}</p>
                      <p className="text-gray-400">{post.date}</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blog; 